﻿import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule, MatTabsModule, MatProgressBarModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';

// angular & 3rd-party components/controls

import { ChartModule } from 'angular-highcharts';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { SelectModule } from 'angular2-select';
import { GaugeModule } from '../../../3rd-party/gauge';
import { AccordionModule } from 'ngx-accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {ChartModule as ChartJsModule} from 'primeng/chart';

// per-spec components
import * as comp from '../';

// per-spec directives
import { FileChooseDirective } from '../../directives/file-chooser.directive';
import { ListHoverDirective } from '../../directives/list-hover.directive';
import { PaginationDirective } from '../../directives/pagination.directive';
import { StopPropagationDirective } from '../../directives/stop-propagation.directive';

// per-spec pipes
import * as pipes from '../../pipes'
import { QuillModule } from 'ngx-quill';
import { QuillEditorHelperService } from './quill-editor/quill-editor-helper.service';
import { CollegePaginationDirective } from 'app/directives/college-pagination.directive';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ChatArchiveParentComponent } from '../chat-archive-parent/chat-archive-parent.component';
import { EprepBannerComponent } from '../eprep-banner/eprep-banner.component';
import { MyCapComponent } from '../my-cap/my-cap.component';

export const sharedModuleList = [

  /* 3rd party component */
  comp.TestScoresComponent,
  comp.GpaComponent,
  comp.AddEventComponent,
  comp.AdminReportComponent,
  comp.AdmissionsComponent,
  comp.ArticlesComponent,
  comp.ArticleModalComponent,
  comp.AlertModalComponent,
  comp.CareerModalComponent,
  comp.StudentDocumentUploadComponent,
  comp.AssesmentComponent,
  comp.CoachingHubComponent,
  comp.CollegeDetailComponent,
  comp.CollegeListComponent,
  comp.CollegeSocialGraphComponent,
  comp.CollegeStatsComponent,
  comp.ComposeMessageModalComponent,
  comp.ConfirmModalComponent,
  comp.CustomBrickAssignmentComponent,
  comp.DegreesMajorComponent,
  comp.DivisionScholarshipsComponent,
  comp.FaqComponent,
  comp.FinancialAidContactComponent,
  comp.AverageNetPriceComponent,
  comp.FreshmanApplicationComponent,
  comp.HeatMapComponent,
  comp.HeatMapBrickModalComponent,
  comp.IntramuralComponent,
  comp.MenuCoachInfoComponent,
  comp.MessageComposeComponent,
  comp.MessageFileUploadComponent,
  comp.MessageFilePreviewComponent,
  comp.MessageGridComponent,
  comp.MessageListComponent,
  comp.MessageThreadComponent,
  comp.MessageThreadNewComponent,
  comp.ActScoreListComponent,
  comp.ApScoreListComponent,
  comp.PersonalBestsComponent,
  comp.PreActScoreListComponent,
  comp.PsatScoreListComponent,
  comp.SatScoreListComponent,
  comp.SatSubjectListComponent,
  comp.NotesCardComponent,
  comp.ParentCareersComponent,
  comp.ParentChildCollegesComponent,
  comp.ParentChildComponent,
  comp.ParentChildMyMessagesComponent,
  comp.ParentChildPlanComponent,
  comp.ParentChildSummaryComponent,
  comp.ParentHomeComponent,
  comp.ParentMessageTabsComponent,
  comp.PlanProgressComponent,
  comp.QuickFactsComponent,
  comp.RegionalMapComponent,
  comp.ShowHowItWorksComponent,
  comp.StudentAcademicAdditionalCardComponent,
  comp.StudentAcademicCardComponent,
  comp.StudentAccommodationsCardComponent,
  comp.StudentActivitiesPanelComponent,
  comp.StudentAdditionalPanelComponent,
  comp.StudentCollegeSearchComponent,
  comp.StudentCommunicationsComponent,
  comp.StudentContactAddressComponent,
  comp.StudentContactCardComponent,
  comp.StudentContactEmailComponent,
  comp.StudentContactPhoneComponent,
  comp.StudentDocumentsComponent,
  comp.StudentExploreComponent,
  comp.StudentGeographyCardComponent,
  comp.StudentSettingsCardComponent,
  comp.StudentIdentityCardComponent,
  comp.StudentLibraryComponent,
  comp.StudentMajorsCardComponent,
  comp.StudentMusicPanelComponent,
  comp.StudentProfileActivitiesComponent,
  comp.StudentProfileComponent,
  comp.StudentProfileContainerComponent,
  comp.ManageYourSubscriptionComponent,
  comp.StudentProfileExperienceComponent,
  comp.StudentProfilePageTwoComponent,
  comp.StudentRotcPanelComponent,
  comp.StudentScholasticCardComponent,
  comp.StudentSocialCardComponent,
  comp.StudentSportsPanelComponent,
  comp.StudentWorkCardComponent,
  comp.SupportServicesComponent,
  comp.TableHeadComponent,
  comp.TestPrepComponent,
  comp.TransferAdmissionsComponent,
  comp.TutoringComponent,
  comp.VideosComponent,
  comp.MinuteVideosComponent,
  comp.BuildInfoComponent,
  comp.LoaderComponent,
  ChatArchiveParentComponent,
  EprepBannerComponent,
  MyCapComponent,
  /* Pipes & Directives */
  StopPropagationDirective,
  FileChooseDirective,
  ListHoverDirective,
  PaginationDirective,
  CollegePaginationDirective,
  pipes.BreadTextTransform,
  pipes.DotsPipe,
  pipes.EscapeHtmlPipe,
  pipes.ExcludeFilterPipe,
  pipes.FileExtensionPipe,
  pipes.FilterPipe,
  pipes.Format,
  pipes.OrderBy,
  pipes.PhoneNoPipe,
  pipes.RemoveCommaPipe,
  pipes.CommaPipe,
  pipes.RoundPipe,
  pipes.SafePipe,
  pipes.SafeHtml,
  pipes.ShortString,
  pipes.SplitPipe,
  pipes.StringLength,
  pipes.UserNameSwitchPipe
];
@NgModule({
  declarations: [...sharedModuleList, ],
   imports: [
    AccordionModule,
    BsDatepickerModule.forRoot(),
    ChartModule,
    ChartJsModule,
    CommonModule,
    NgMultiSelectDropDownModule.forRoot(),
    FormsModule,
    GaugeModule,
    MatSliderModule,
    MatProgressBarModule,
    MatTabsModule,
    NguiAutoCompleteModule,
    ReactiveFormsModule,
    RoundProgressModule,
    RouterModule,
    SelectModule,
    AngularMultiSelectModule,
    QuillModule

  ],
  exports: [
    AccordionModule,
    ChartModule,
    CommonModule,
    FormsModule,
    MatSliderModule,
    MatProgressBarModule,
    MatTabsModule,
    NguiAutoCompleteModule,
    ReactiveFormsModule,
    SelectModule,
    AngularMultiSelectModule,
    QuillModule,
    BsDatepickerModule,
    ...sharedModuleList,
  ],
  providers: [QuillEditorHelperService, DatePipe],
  entryComponents: [
    comp.ComposeMessageModalComponent,
    comp.MessageFilePreviewComponent,
    comp.HeatMapBrickModalComponent,
    comp.ArticleModalComponent,
    comp.ConfirmModalComponent,
    comp.AlertModalComponent,
    comp.CareerModalComponent,
    comp.StudentDocumentUploadComponent
  ]
})
export class SharedModule { }
